// extracted by mini-css-extract-plugin
export default {"bubble":"Bubble__bubble___ACwPR","leftBubble":"Bubble__leftBubble___tDvtl"};